import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SchoolShell from '../../components/school/SchoolShell';
import { useToast } from '../../context/ToastContext';
import api from '../../utils/api';

const SUBJECTS_BY_CLASS = {
  6: ['Mathematics', 'Science', 'Social Science', 'English', 'Hindi'],
  7: ['Mathematics', 'Science', 'Social Science', 'English', 'Hindi'],
  8: ['Mathematics', 'Science', 'Social Science', 'English', 'Hindi'],
  9: ['Mathematics', 'Science', 'Social Science', 'English', 'Hindi', 'AI / CT'],
  10: ['Mathematics', 'Science', 'Social Science', 'English', 'Hindi', 'AI / CT'],
};

const SchoolAddStudentPage = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', class_id: '10', subjects: SUBJECTS_BY_CLASS[10], password: '' });
  const [loading, setLoading] = useState(false);
  const [generatedUsername, setGeneratedUsername] = useState(null);
  const { error } = useToast();
  const navigate = useNavigate();

  const toggleSubject = (subj) => {
    setForm(p => ({ ...p, subjects: p.subjects.includes(subj) ? p.subjects.filter(s => s !== subj) : [...p.subjects, subj] }));
  };

  const handleClassChange = (cls) => {
    setForm(p => ({ ...p, class_id: cls, subjects: SUBJECTS_BY_CLASS[parseInt(cls)] || [] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.password) return error('Name and password are required.');
    if (form.subjects.length === 0) return error('Select at least one subject.');
    setLoading(true);
    try {
      const res = await api.post('/schools/students/add', form);
      const msg = res.data.message || '';
      const uname = msg.includes('Username:') ? msg.split('Username: ')[1] : form.name.toLowerCase().replace(/\s+/g, '.');
      setGeneratedUsername(uname);
    } catch (err) {
      error(err.response?.data?.message || 'Failed to add student.');
    } finally { setLoading(false); }
  };

  const handleAddAnother = () => {
    setGeneratedUsername(null);
    setForm({ name: '', email: '', phone: '', class_id: '10', subjects: SUBJECTS_BY_CLASS[10], password: '' });
  };

  if (generatedUsername) {
    return (
      <SchoolShell title="Add Student" subtitle="Add a new student to your school">
        <div style={{ maxWidth: '500px' }}>
          <div style={{ background: '#E6F4EC', border: '1px solid #1B7F3E', borderRadius: '12px', padding: '24px' }}>
            <div style={{ fontSize: '16px', fontWeight: 800, color: '#1B7F3E', marginBottom: '8px' }}>✅ Student Added Successfully!</div>
            <div style={{ fontSize: '13px', color: '#1A1A2E', marginBottom: '12px' }}>Share these login credentials with the student:</div>
            <div style={{ background: 'white', borderRadius: '8px', padding: '16px', marginBottom: '16px' }}>
              <div style={{ fontSize: '13px', marginBottom: '6px' }}>
                <strong>Username:</strong> <span style={{ color: '#6B4EFF', fontWeight: 800, fontSize: '16px' }}>{generatedUsername}</span>
              </div>
              <div style={{ fontSize: '13px' }}>
                <strong>Password:</strong> The password you set during registration
              </div>
              <div style={{ fontSize: '11px', color: '#94A3B8', marginTop: '8px' }}>
                Student can login at mypersonalguruji.com using username + password
              </div>
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={handleAddAnother}
                style={{ background: '#1B7F3E', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 18px', fontSize: '13px', fontWeight: 700, cursor: 'pointer' }}>
                + Add Another Student
              </button>
              <button onClick={() => navigate('/school/students')}
                style={{ background: 'white', color: '#1A1A2E', border: '1px solid #E2E8F0', borderRadius: '8px', padding: '10px 18px', fontSize: '13px', fontWeight: 700, cursor: 'pointer' }}>
                View All Students
              </button>
            </div>
          </div>
        </div>
      </SchoolShell>
    );
  }

  return (
    <SchoolShell title="Add Student" subtitle="Add a new student to your school">
      <div style={{ maxWidth: '600px' }}>
        <div style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '12px', padding: '24px' }}>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginBottom: '14px' }}>
              <div>
                <label style={{ fontSize: '11px', fontWeight: 700, color: '#64748B', display: 'block', marginBottom: '5px' }}>Student Name *</label>
                <input value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} placeholder="Full name" required
                  style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #E2E8F0', fontSize: '13px', outline: 'none', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ fontSize: '11px', fontWeight: 700, color: '#64748B', display: 'block', marginBottom: '5px' }}>Class *</label>
                <select value={form.class_id} onChange={e => handleClassChange(e.target.value)}
                  style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #E2E8F0', fontSize: '13px', outline: 'none' }}>
                  {[6,7,8,9,10].map(c => <option key={c} value={c}>Class {c}</option>)}
                </select>
              </div>
              <div>
                <label style={{ fontSize: '11px', fontWeight: 700, color: '#64748B', display: 'block', marginBottom: '5px' }}>Email (optional)</label>
                <input type="email" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} placeholder="student@email.com"
                  style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #E2E8F0', fontSize: '13px', outline: 'none', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ fontSize: '11px', fontWeight: 700, color: '#64748B', display: 'block', marginBottom: '5px' }}>Phone (optional)</label>
                <input value={form.phone} onChange={e => setForm(p => ({ ...p, phone: e.target.value }))} placeholder="10-digit mobile"
                  style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #E2E8F0', fontSize: '13px', outline: 'none', boxSizing: 'border-box' }} />
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={{ fontSize: '11px', fontWeight: 700, color: '#64748B', display: 'block', marginBottom: '5px' }}>Password *</label>
                <input type="password" value={form.password} onChange={e => setForm(p => ({ ...p, password: e.target.value }))} placeholder="Min. 8 characters" required
                  style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #E2E8F0', fontSize: '13px', outline: 'none', boxSizing: 'border-box' }} />
              </div>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ fontSize: '11px', fontWeight: 700, color: '#64748B', display: 'block', marginBottom: '8px' }}>Subjects *</label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {(SUBJECTS_BY_CLASS[parseInt(form.class_id)] || []).map(s => (
                  <button key={s} type="button" onClick={() => toggleSubject(s)}
                    style={{ padding: '6px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: 700, border: form.subjects.includes(s) ? 'none' : '1px solid #E2E8F0', background: form.subjects.includes(s) ? '#1A3C6E' : 'white', color: form.subjects.includes(s) ? 'white' : '#64748B', cursor: 'pointer' }}>
                    {s}
                  </button>
                ))}
              </div>
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button type="submit" disabled={loading}
                style={{ flex: 1, background: '#FF6B00', color: 'white', border: 'none', borderRadius: '8px', padding: '11px', fontSize: '13px', fontWeight: 800, cursor: 'pointer', opacity: loading ? 0.7 : 1 }}>
                {loading ? 'Adding...' : '+ Add Student'}
              </button>
              <button type="button" onClick={() => navigate('/school/students')}
                style={{ padding: '11px 20px', background: 'white', color: '#64748B', border: '1px solid #E2E8F0', borderRadius: '8px', fontSize: '13px', fontWeight: 700, cursor: 'pointer' }}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </SchoolShell>
  );
};

export default SchoolAddStudentPage;
